import type { CSSProperties } from 'react';

export function safeAreaFixedOverlayStyle(safeTop: number): CSSProperties {
  return {
    display: 'flex',
    height: safeTop,
    backgroundColor: '#fff',
    zIndex: 9999999999999,
    top: 0,
    left: 0,
    right: 0,
    position: 'fixed',
  };
}

export function mainContainerStyle(safeTop: number): CSSProperties {
  return {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: safeTop,
  };
}
